import React, { useState } from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import DashboardNav from "../dashboardNav";
import "../style.scss";
import AccountInformationContent from "./accountInformationContent";

const AccountInformation = () => {
  const [activeItem, setActiveItem] = useState(1);
  const onClickHandler = () => setActiveItem(1);

  return (
    <MDBContainer
      id={`account-dashboard-container`}
      fluid
      className="m-0 dashboard-container"
    >
      <MDBRow className="m-0 p-0  align-items-stretch">
        <MDBCol
          xl="3"
          lg="3"
          md="4"
          sm="12"
          xs="12"
          className="m-0 p-0 main-navbar-account"
        >
          <DashboardNav
            activeItem={activeItem}
            onClickHandler={onClickHandler}
          />
        </MDBCol>
        <MDBCol xl="9" lg="9" md="8" sm="12" xs="12" className="m-0 p-0">
          <AccountInformationContent />
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
};

export default AccountInformation;
